// Module
var code = "<niveaux-hierarchiques-form ng-if=\"!$ctrl.loading\" trame=\"$ctrl.niveaux\" elements=\"$ctrl.elements\" model=\"$ctrl.values\"> </niveaux-hierarchiques-form> ";
// Exports
module.exports = code;